import Icon from '@ant-design/icons';

const MonitorSvg = (props: any) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.9514 13.2047L14.0061 9.875V2.625C14.0061 2.34844 13.7826 2.125 13.5061 2.125H2.50607C2.22951 2.125 2.00607 2.34844 2.00607 2.625V9.875L1.06076 13.2047C0.943572 13.5312 1.1842 13.875 1.53107 13.875H14.4811C14.8279 13.875 15.0686 13.5312 14.9514 13.2047ZM3.13107 3.25H12.8811L8.3217 6.25781L3.13107 9.42188V3.25ZM6.69826 12.75L6.82482 12.1719H9.17326L9.29982 12.75H6.69826ZM10.1983 12.75L9.89982 11.3953C9.88732 11.3375 9.83576 11.2969 9.77795 11.2969H6.2217C6.16232 11.2969 6.11232 11.3375 6.09982 11.3953L5.80138 12.75H2.3592L3.02013 10.4219H12.992L13.6529 12.75H10.1983Z" fill="currentColor" />
    </svg>
  );
};

export const MonitorIcon = (props: any) => <Icon component={MonitorSvg} {...props} />;
